<template>
  <ul class="m-0 flex list-none flex-col gap-2 p-0">
    <slot />
  </ul>
</template>
